export default __webpack_public_path__ + "static/media/dtwzq.11e1c69d.png";